import { render, staticRenderFns } from "./centerAbsentExPeparWise.vue?vue&type=template&id=1528e33b&"
import script from "./centerAbsentExPeparWise.vue?vue&type=script&lang=js&"
export * from "./centerAbsentExPeparWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports